<template>
  <div class="overflow-x-auto py-2 w-min">
    <div class="flex items-center gap-2 w-min">
      <router-link
        class="px-4 h-12 flex items-center text-sm whitespace-nowrap !no-underline !text-black rounded-md !shadow"
        :class="{
          'pointer-events-none bg-gray-50': !pages.previous,
        }"
        :to="{
          path: to,
          query: {
            ...$route.query,
            page: pages.previous ? pages.previous : '',
          },
        }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </router-link>
      <div v-for="pageItem in pagesDisplay" :key="pageItem.index">
        <router-link
          v-if="pageItem.useRoute"
          class="px-4 h-12 flex items-center text-sm whitespace-nowrap !no-underline !text-black rounded-md !shadow"
          :class="{
            'bg-sky-600': currentPage === pageItem.route,
            'bg-sky-400': currentPage !== pageItem.route,
          }"
          :to="{
            path: to,
            query: {
              ...$route.query,
              page: pageItem.route
            }
          }"
        >
          {{ pageItem.display }}
        </router-link>
        <div v-else>
          <input
            class="px-2 h-12 w-16 flex items-center text-center whitespace-nowrap !no-underline !text-black rounded-md !shadow"
            placeholder="..."
            ref="customPageInput"
            @input="event => (customPage = event.target.value)"
            @keydown.enter="onCustomPageInput()"
            @focusout="onCustomPageInput()"
          />
        </div>
      </div>
      <router-link
        class="px-4 h-12 flex items-center whitespace-nowrap !no-underline !text-black rounded-md !shadow"
        :class="{
          'pointer-events-none bg-gray-50': !pages.next,
        }"
        :to="{
          path: to,
          query: {
            ...$route.query,
            page: pages.next
              ? pages.next
              : ''
          },
        }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pages: Object,
    to: String,
  },
  data() {
    return {
      customPage: undefined,
      currentPage: 1,
    }
  },
  methods: {
    onCustomPageInput() {
      for (const inputField of this.$refs.customPageInput) {
        inputField.value = ''
      }

      let customPage = parseInt(this.customPage)
      if (isNaN(customPage)) {
        return
      } else if (customPage <= 0 || customPage > this.pages.total) {
        customPage = 1
      }

      this.$router.push({
        path: this.$route.path,
        query: {
          page: customPage,
        },
      })
    },
  },
  watch: {
    '$route.query.page': function (newValue) {
      newValue = parseInt(newValue)
      if (isNaN(newValue) || newValue <= 0 || newValue > this.pages.total) {
        this.currentPage = 1
      } else {
        this.currentPage = newValue
      }
    },
  },
  mounted() {
    let page = parseInt(this.$route.query.page)
    if (
      isNaN(page) ||
      this.pages === undefined ||
      page <= 0 ||
      page > this.pages.total
    ) {
      this.currentPage = 1
    } else {
      this.currentPage = page
    }
  },
  computed: {
    pagesDisplay() {
      if (this.pages === undefined || this.pages.page_range === undefined) {
        return []
      }

      return this.pages.page_range.map((element, index) => {
        if (element !== '…') {
          return {
            index: index,
            display: element,
            useRoute: true,
            route: element,
          }
        } else {
          return {
            index: index,
            display: '...',
            useRoute: false,
          }
        }
      })
    },
  },
}
</script>

<style></style>
